import { string } from 'prop-types';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import { copyToClipBoard } from '../../utils/helperFunctions';
import { useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import ClickAwayListener from '@mui/material/ClickAwayListener';

const CopyLinkButton = ({ linkToCopy }) => {
	const [tooltipOpen, setTooltipOpen] = useState(false);

	const handleTooltipClose = () => {
		setTooltipOpen(false);
	};

	// When the 'Copy link' button is clicked, the 'Copied!' tooltip will show for 1 second to let them know the
	// link was copied to the clipboard.
	const handleTooltipOpen = () => {
		setTooltipOpen(true);

		setTimeout(() => handleTooltipClose(), 1000);
	};

	return (
		<ClickAwayListener onClickAway={handleTooltipClose}>
			<Tooltip
				PopperProps={{
					disablePortal: true,
				}}
				onClose={handleTooltipClose}
				open={tooltipOpen}
				disableFocusListener
				disableHoverListener
				disableTouchListener
				title="Copied!"
			>
				<Button
					onClick={() => {
						copyToClipBoard(linkToCopy);
						handleTooltipOpen();
					}}
					sx={{ textTransform: 'none' }}
				>
					<Stack direction="row" sx={{ color: 'text.disabled' }}>
						<InsertLinkIcon />
						<Typography ml={1} variant="body1">
							Copy link
						</Typography>
					</Stack>
				</Button>
			</Tooltip>
		</ClickAwayListener>
	);
};

CopyLinkButton.propTypes = {
	/*
	 * The link that we want to copy to the clipboard
	 */
	linkToCopy: string,
};

export default CopyLinkButton;
